import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CommonPropertyDetailPageService } from '../common-property-detail-page.service';

@Component({
  selector: 'app-land-price-analysis-chart',
  templateUrl: './land-price-analysis-chart.component.html',
  styleUrls: ['./land-price-analysis-chart.component.scss']
})
export class LandPriceAnalysisChartComponent {
  @Input() chartId: string = '';
  @Input() Property_Uid: string = '';
  @Input() title: string = '';
  @Input() type: string = '';
  projLandPriceAnalysisLoading: boolean = false;
  landPriceGraphData: any = null;

  isFirstload=true;
  @Output() isEmpatyCheck = new EventEmitter();

  constructor(private commonPropService: CommonPropertyDetailPageService) { }

    ngOnInit(): void {
       this.fetchData();
    }

    ngOnChanges(changes: SimpleChanges): void {
      if (changes['Property_Uid']) {
        this.fetchData();
      }
    }

    fetchData(filter:any=null){
      let params:string = '';
      if(filter){
        const filterdata = Object.entries(filter).reduce((acc, [key, value]) => {
          if (value) acc[key] = value;
          return acc;
        }, {} as Record<string, any>);
        params = Object.keys(filterdata).length === 0 ? '' : JSON.stringify(filterdata).replace(/[+]/g, '%2B');
        if(params) {
          params = encodeURIComponent(params)
        };
      }

      this.projLandPriceAnalysisLoading=true;
      this.commonPropService.getLandPriceAnalysis(this.Property_Uid, this.type, params).subscribe({
        next: (res:any)=>{
          this.projLandPriceAnalysisLoading=false;
          if(res.status == 200){
            this.landPriceGraphData = res.data;
          }else{
            this.landPriceGraphData = null;
            this.updateSection();
          }
        },
        error:(err)=>{
          this.projLandPriceAnalysisLoading=false;
          this.landPriceGraphData = null;
          this.updateSection();
        }
      })
    }

  dropdownChange(filter: any) {
    if (this.isFirstload) {
      this.isFirstload = false;
    }
    this.fetchData(filter);
  }
   updateSection(){
    if(this.isFirstload && !this.landPriceGraphData){
      this.isEmpatyCheck.emit(true);
    }
  }
}
